import { useState, useRef } from 'react'
import { useModalBehavior } from '../../../hooks/useModalBehavior'
import './FilterDropdown.css'

interface FilterDropdownProps {
    label: string
    icon: string
    options: readonly string[]
    selected: string[]
    onSelect: (selected: string[]) => void
    onClear: () => void
}

export default function FilterDropdown({ label, icon, options, selected, onSelect, onClear }: Readonly<FilterDropdownProps>) {
    const [isOpen, setIsOpen] = useState(false)
    const modalRef = useRef<HTMLDivElement>(null)

    // Use shared modal behavior hook
    useModalBehavior({ modalRef, onClose: () => setIsOpen(false) })

    const toggleOption = (option: string) => {
        if (selected.includes(option)) {
            onSelect(selected.filter((s) => s !== option))
        } else {
            onSelect([...selected, option])
        }
    }

    const hasSelection = selected.length > 0

    return (
        <div className="filter-dropdown" ref={modalRef}>
            <button className={`filter-trigger ${hasSelection ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen}>
                <span className="filter-icon">{icon}</span>
                <span className="filter-label">{label}</span>
                {hasSelection && <span className="filter-count">{selected.length}</span>}
                <span className="filter-chevron">{isOpen ? '▲' : '▼'}</span>
            </button>

            {isOpen && (
                <div className="filter-menu">
                    {hasSelection && (
                        <button
                            className="filter-clear-btn"
                            onClick={(e) => {
                                e.stopPropagation()
                                onClear()
                            }}
                        >
                            ✕ Limpiar filtro
                        </button>
                    )}
                    <div className="filter-options">
                        {options.map((option) => (
                            <label key={option} className="filter-option">
                                <input type="checkbox" checked={selected.includes(option)} onChange={() => toggleOption(option)} />
                                <span className="filter-checkbox"></span>
                                <span className="filter-option-text">{option}</span>
                            </label>
                        ))}
                    </div>
                    {options.length === 0 && <div className="filter-empty">Sin opciones</div>}
                </div>
            )}
        </div>
    )
}
